import Vue from 'vue';
import App from './App.vue';
import VueCookie from 'vue-cookie'

import './utils/filters';
import './utils/directives';

import { Message, Loading } from 'element-ui';

import { store } from './store/index';
import router from './router';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';

// const components = { Loading };
// for (let component of Object.values(components)) {
//   Vue.component(component.name, component);
// }

Vue.use(Loading);
locale.use(lang);
Vue.prototype.$message = Message;
Vue.config.productionTip = false;
Vue.use(VueCookie)

if (process.env.NODE_ENV === 'development') {
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app');
} else {
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app');
}
